define('customerInternalCommentsListCommentView',[
  'module',
  'backbone',
  'underscore',
  'settings',
  'customerInternalCommentsEditView',
  'ordersDetailOrderCommentsListCommentTagsView',
  'commentView',
  'commentsTags',
  'template!ordersDetailOrderCommentsListCommentView'
], function(
  Module,
  Backbone,
  _,
  Settings,
  EditView,
  TagsView,
  CommentView,
  Tags,
  Tpl
) {
  'use strict';

  Module.exports = CommentView.extend({    
    className: 'comment-view ' + CommentView.prototype.className,
    template: Tpl,    
    EditView: EditView,

    ui: _.extend({}, CommentView.prototype.ui, {
      tagsRegion: '.tags-region'
    }),   

    regions: _.extend({}, CommentView.prototype.regions, {
      tagsRegion: '.tags-region'
    }),
    
    onRender: function() {
      CommentView.prototype.onRender.apply(this, arguments);

      if (this.model.get('tags') && this.model.get('tags') !== '')
          this.ui.tagsRegion.css('display', 'flex');
      else
        this.ui.tagsRegion.hide();

      if (this.model.get('tags') && this.model.get('tags') !== '') {
        this.tagsCollection = new Backbone.Collection(); 
        _.each(this.model.get('tags').split(','), function (t) {
          var tagModel = null;
          _.each(Tags.get(), function(tag) {
            if(tag.id === t)
              tagModel = new Backbone.Model(tag);
          }, this);
         
          if(tagModel)
            this.tagsCollection.add(tagModel);
        }, this);

        if(Settings.configValue('advancedMode') === true) {
          this.tagsView = new TagsView({
            collection: this.tagsCollection, 
            order: this.options.order
          });

          this.tagsView.on('remove', function (view) {    
            this.model.removeTag(view.model.get('id'));
            this.model.save(this.options.secId).done(_.bind(function () {
              this.options.listView.fetch();
            }, this)).fail(_.bind(function () {
              this.options.listView.fetch();
            }, this));
          }, this);

          this.getRegion('tagsRegion').show(this.tagsView);
        }
      }      
    },

    onEdit: function () {
      EditView.prototype.open({
        model: this.model,
        title: _.i18n('common.comment'),
        onConfirm: _.bind(function (value, tags = []) {     
          this.model.set('comment', value ? value : '');
          this.model.set('refUserpid', this.model.get('userpid'));
          this.model.unset('content');
          this.model.unset('modDate');
          this.model.unset('userpid');

          var tagsIds = [];
          _.each(tags, function (tag) {
            tagsIds.push(tag.get('id'));
          }, this);   
       
          this.model.set('tags', tagsIds.join(','));

          this.model.save(this.options.secId).done(_.bind(function() {
            this.options.listView.fetch();
          }, this)).fail(_.bind(function() {
            this.options.listView.fetch();
          }, this));
        }, this)
      });
    }
  });   
});
